import { useState, useRef, useEffect } from "react";
import './CricketBanner.css';

import boys from "../../../images/boy.png";
import girls from "../../../images/girl.png";
import boyss from "../../../images/boy1.png";
import legends from "../../../images/legend.png";


const CricketBanner = () => {
    const [isPopupCricketVisible, setPopupCricketVisible] = useState(false);
  
    const toggleCricketPopup = () => {
      setPopupCricketVisible(!isPopupCricketVisible);
    };
  
    const refreshRef = useRef(null);
    const [isRefreshVisible, setIsRefreshVisible] = useState(false);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsRefreshVisible(true);
            }
          });
        },
        { threshold: 0.5 }
      );
  
      if (refreshRef.current) {
        observer.observe(refreshRef.current);
      }
  
      const refreshRefCurrentValue = refreshRef.current;
  
      return () => {
        if (refreshRefCurrentValue) {
          observer.unobserve(refreshRefCurrentValue);
        }
      };
    }, []);
  
    return (
      <div
        className="cricket-banner"
        id="campa-cricket"
        style={{
          //  minWidth: '100%',
          minHeight: "100%",
          position: "relative",
          backgroundImage: `url("	https://campabeveragesadmin.ril.com/uploads/Scroll_1_Desktop_Background_934a1c99eb.png")`,
          //backgroundSize: '100%',
          backgroundPosition: "center",
          // backgroundRepeat: 'no-repeat',
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundSize: "cover",
        }}
      >
        {/* <img src="	https://campabeveragesadmin.ril.com/uploads/Scroll_1_Desktop_Background_934a1c99eb.png"/> */}
          <div
            className="columnflex"
            style={{
              minWidth: "666px",
              minHeight: "120px",
              backgroundPosition: "center",
              position: "absolute",
              transform: "translate(-50%, -260%)",
              left: "50%",
              zIndex: "1",
            }}
          >
            <h2
              className="wrap"
              style={{
                background: "linear-gradient(180deg, #fff, hsla(0, 0%, 100%, 0.3))",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                //fontSize: '64px',
                fontSize: "clamp(24px, 5vw, 64px)",
                textTransform: "uppercase",
                whiteSpace: "nowrap",
                fontFamily: "LogikWide",
                fontStyle: "italic",
                lineHeight: "normal",
                //marginTop: '-80px',
                //  marginBottom: '1px',
                margin: "0",
                padding: "0",
              }}
            >
              Refresh The Josh!
            </h2>
            <h5
              className="cricket-banner-sub-text"
              style={{
                color: "#fff",
                fontSize: "22px",
                textAlign: "center",
                margin: "0",
                padding: "0",
                fontFamily: "LogikWide",
              }}
            >
              Cheer with Campa Cricket, from the House of Campa
            </h5>
          </div>
          <button
            className="buttonstyle watch-now-button-2"
            style={{
              position: "absolute",
              display: "flex",
              top: "55%",
              left: "50%",
              transform: "translate(-50%, -450%)",
              padding: "20px 18px",
              backgroundColor: "transparent",
              border: "1px solid  #fff",
              cursor: "pointer",
              borderRadius: "10px",
              zIndex: 1,
              fontFamily: "LogikWide",
              fontSize: "18px",
              fontWeight: 700,
              overflow: "hidden",
              color: "#fff",
              width: "fit-content",
              gap: "8px",
            }}
            onClick={toggleCricketPopup}
            onMouseEnter={(e) =>
              ((e.target as HTMLButtonElement).style.backgroundColor = "purple")
            }
            onMouseLeave={(e) =>
              ((e.target as HTMLButtonElement).style.backgroundColor =
                "transparent")
            }
          >
            WATCH NOW
            <img
              src={`${process.env.REACT_APP_BASENAME}/svgs/play_icon.svg`}
              alt="play icon"
              style={{
                width: "24px",
                height: "24px",
              }}
            />
          </button>
  
        {isPopupCricketVisible && (
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10,
              width: "70%",
              height: "70%",
              position: "absolute",
              transform: "translate(-50%, -50%)",
              top: "50%",
              left: "50%",
            }}
          >
            <img
              src="/cross.png"
              alt="Close"
              onClick={() => setPopupCricketVisible(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "5px",
                width: "40px",
                height: "40px",
                cursor: "pointer",
                zIndex: 3,
                color: "transparent",
              }}
            />
            <iframe
              className="screensize1"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/5Shp6syND6c"
              title="#RefreshTheJosh with Campa Cricket &amp; be a part of India&#39;s biggest cheer chain!"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        )}
  
        <div style={{ display: "flex", marginLeft: "30%", position: "relative" }}>
          {" "}
          {/* Flex container */}
          <img
            className="middlebottle"
            ref={refreshRef}
            src="https://campabeveragesadmin.ril.com/uploads/Campa_cricket_Bottle_238881cf10.png" // Replace with your bottle image URL
            alt="cricket-bottle"
            style={{
              // position: 'absolute',
              position: "absolute",
              top: "25%",
              left: "-19%",
              // transform: 'translateY(16%)',
              // border: '1px solid',
              width: "50%",
              // cursor: 'pointer',
              zIndex: 2,
              maxWidth: "100%",
              //animation: 'slideDown 0.4s ease-out forwards',
              animation: isRefreshVisible
                ? "slideDown 0.8s ease-out forwards"
                : "none",
            }}
          />
          <img
            className="boys"
            ref={refreshRef}
            style={{
              position: "absolute",
  
              zIndex: 1,
              transform: "scale(0.9)",
              // animation: 'slideUp 1.8s ease-out forwards',
              animation: isRefreshVisible
                ? "slideUp 1.8s ease-out forwards"
                : "none",
              width: "350px",
            }}
            src={boys}
            alt="boys"
          />
          <img
            className="legend"
            ref={refreshRef}
            style={{
              position: "absolute",
              transform: "scale(0.5)",
              zIndex: 2,
              //animation: 'slideUp 1.8s ease-out forwards',
              animation: isRefreshVisible
                ? "slideUp 1.8s ease-out forwards"
                : "none",
            }}
            src={legends}
            alt="legends"
          />
          {/* <img
                          style={{
                              transform: 'scaleY(1.3)',
                              transformOrigin: 'top',
                              width: 'auto', zIndex: 2
                          }}
                          src={bottless}
                          alt="bottless"
                      /> */}
          <div style={{ position: "relative", right: "15%" }}>
            <img
              className="girls"
              ref={refreshRef}
              style={{
                marginTop: "65%",
                //  animation: 'slideUp 1.8s ease-out forwards'
                animation: isRefreshVisible
                  ? "slideUp 1.8s ease-out forwards"
                  : "none",
              }}
              src={girls}
              alt="girls"
            />
          </div>
          <div
            className="boy"
            style={{
              position: "absolute",
              zIndex: 1,
              transform: "scale(0.8)",
              width: "270px",
            }}
          >
            <img
              ref={refreshRef}
              style={{
                //animation: 'slideUp 1.8s ease-out forwards',
                animation: isRefreshVisible
                  ? "slideUp 1.8s ease-out forwards"
                  : "none",
              }}
              src={boyss}
              alt="boyss"
            />
          </div>
        </div>
      </div>
    );
  };

export default CricketBanner;